export class DistintoAmbientalModel {

  id: number;
  nombre: string;

  constructor() {
    this.id = null;
    this.nombre = '';
  }
}
